export {
  WAIVER_DOCUMENTS,
  isWaiverDocumentId,
  isPortalWaiverDocumentId,
  type WaiverDocumentId,
  type PortalWaiverDocumentId,
} from '@ftlo/worker-shared/waiverDocuments';
import type { WaiverDocumentId } from '@ftlo/worker-shared/waiverDocuments';

export interface WaiverSection {
  title: string;
  body: string;
}

export async function loadWaiverSections(
  id: WaiverDocumentId,
): Promise<WaiverSection[]> {
  const module = await import(`./documents/${id}.ts`);
  return module.default;
}
